export const GENIUS_OLYMPIAD_ASSESSMENT_LABEL = "Genius Olympiad Assessment";

type GeniusReportNavigate = (
  to: string,
  options?: { replace?: boolean; state?: unknown },
) => void;

/** ILTS test home — Back from Genius report should land here, not instructions. */
export function getGeniusDeeplinkTestHomePath(): string {
  return "/tests/ilts?tab=attempted";
}

export function getGeniusReportNavigationState(testSeriesLabel?: string) {
  return {
    testSeriesLabel: testSeriesLabel ?? GENIUS_OLYMPIAD_ASSESSMENT_LABEL,
  };
}

export function getGeniusDeeplinkTestHomeState(testSeriesLabel?: string) {
  return {
    ...getGeniusReportNavigationState(testSeriesLabel),
    geniusReportBackSeeded: true as const,
  };
}

/**
 * After exam submit / Genius report entry — go to the report in one navigation.
 * React Router 6 ignores a second synchronous navigate in the same tick.
 */
export function navigateGeniusReportWithBackToTestHome(
  navigate: GeniusReportNavigate,
  reportUrl: string,
  testSeriesLabel?: string,
): void {
  navigate(reportUrl, {
    replace: true,
    // Mark back history as seeded so ReportsPage does not re-run
    // seedGeniusReportBackHistory (that navigates away to ILTS first).
    state: getGeniusDeeplinkTestHomeState(testSeriesLabel),
  });
}

/**
 * On the report screen, insert ILTS test home below the report in history
 * so Back lands on Attempted (not instructions/exam).
 */
export function seedGeniusReportBackHistory(
  navigate: GeniusReportNavigate,
  reportPath: string,
  testSeriesLabel?: string,
): void {
  const state = getGeniusDeeplinkTestHomeState(testSeriesLabel);
  navigate(getGeniusDeeplinkTestHomePath(), { replace: true, state });
  Promise.resolve().then(() => {
    navigate(reportPath, { state });
  });
}

export function isGeniusReportBackSeeded(locationState: unknown): boolean {
  return Boolean(
    locationState &&
    typeof locationState === "object" &&
    (locationState as { geniusReportBackSeeded?: boolean })
      .geniusReportBackSeeded,
  );
}
